import angular from 'angular';

import { r2a } from '@/react-tools/react2angular';
import { withControlledInput } from '@/react-tools/withControlledInput';
import { GitlabProjectTable } from '@/react/portainer/registries/CreateView/GitlabProjectsTable/GitlabProjectsTable';
import { MultiRegistrySelectFieldset } from '@/react/components/form-components/MultiRegistrySelectFieldset/MultiRegistrySelectFieldset';
import { RegistryFormDockerhub } from '@/react/portainer/registries/CreateView/RegistryFormDockerhub/RegistryFormDockerhub';
import { withReactQuery } from '@/react-tools/withReactQuery';

export const registriesModule = angular
  .module('portainer.app.react.components.registries', [])
  .component(
    'gitlabProjectSelector',
    r2a(GitlabProjectTable, ['dataset', 'onChange', 'value'])
  )
  .component(
    'multiRegistrySelectFieldset',
    r2a(
      withControlledInput(MultiRegistrySelectFieldset, { value: 'onChange' }),
      [
        'onChange',
        'options',
        'value',
        'placeholder',
        'dataCy',
        'inputId',
        'label',
        'emptyText',
        'showFormControl',
        'showEmptyState',
        'tooltip',
        'setTooltipHtmlMessage',
        'errors',
      ]
    )
  )
  .component(
    'registryFormDockerhub',
    r2a(withReactQuery(RegistryFormDockerhub), [
      'initialValues',
      'onSubmit',
      'submitLabel',
      'isLoading',
      'nameIsUsed',
    ])
  ).name;
